import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useCallback } from 'react';
import { constructCdnUrl, OFFICE_START_RESOURCE_FOLDER, } from '../constructCdnUrl';
export var useConstructCdnUrl = function () {
    var _a, _b;
    var cdnDomain = (_b = (_a = useOfficeComponentContext()) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.cdnDomain;
    return useCallback(function (_a) {
        var _b = _a.folder, folder = _b === void 0 ? OFFICE_START_RESOURCE_FOLDER : _b, fileName = _a.fileName, fileExtension = _a.fileExtension;
        return constructCdnUrl(cdnDomain, folder, fileName, fileExtension);
    }, [cdnDomain]);
};
//# sourceMappingURL=useConstructCdnUrl.js.map